
// Hot Deals copy hot code to use another
// function copyCode(buttonElement) {
//   const code = document.getElementById("codeBlock").innerText.toUpperCase();

//   navigator.clipboard.writeText(code).then(() => {
//     const originalText = buttonElement.innerText;
//     buttonElement.innerText = "Copied..";
//     buttonElement.disabled = true;

//     setTimeout(() => {
//       buttonElement.innerText = originalText;
//       buttonElement.disabled = false;
//     }, 2000);
//   }).catch(err => {
//     console.error("Copy failed", err);
//   });
// } 

// Index Best Seller slick slider
$('.bestsellerpro-slider').slick({
  dots: false,
  speed: 300,
  arrows: false,
  autoplay: false,
  autoplaySpeed: 3000,
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
         arrows: false,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
         arrows: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
// Index Best Seller slick slider 


// Index 14 slick slider
$('.kitchen-slider').slick({
  dots: false,
  arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 476,
      settings: {
        slidesToShow: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        slidesToScroll: 1
      }
    }
  ]
});
// Index 14 slick slider
 

// Index 7 media dynamic height value
document.addEventListener("DOMContentLoaded", function () { 
  function setMediaVideoHeights() {
    console.log("Getting teh Index 7 script");
    const sections = document.querySelectorAll(".sorting-collections");

    sections.forEach(section => {
      const rightCol = section.querySelector(".index-7-rht-col");
      const mediaVideo = section.querySelector(".media_video");

      if (rightCol && mediaVideo) {
        // Only apply height if screen is wider than 1199px
        if (window.innerWidth > 1199) {
          const rightColHeight = rightCol.offsetHeight;

          console.log("Right col height:", rightColHeight );
          mediaVideo.style.height = `${rightColHeight}px`;
        } else {
          // Remove inline height for smaller screens (so CSS takes over)
          mediaVideo.style.height = "";
        }
      }
    });
  } 

  // Run on load
  setMediaVideoHeights();

  // Run again when window resizes
  window.addEventListener("resize", setMediaVideoHeights);
});
// Index 7 media dynamic height value
